import type { InputHTMLAttributes } from "react";
import s from "./ui.module.css";

interface Props extends Omit<InputHTMLAttributes<HTMLInputElement>, "type"> {
  label: string;
  /** Label nur für Screenreader (zum Beispiel in Tabellen) */
  labelVersteckt?: boolean;
}

export function Schalter({ label, labelVersteckt, ...rest }: Props) {
  return (
    <label className={s.schalterZeile}>
      <input type="checkbox" role="switch" className={s.schalter} {...rest} />
      <span className={labelVersteckt ? s.nurLeser : undefined}>{label}</span>
    </label>
  );
}
